/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  Chip,
  Col,
  Dialog,
  FabButton,
  Flex,
  Icon,
  InputField,
  Row,
  SelectField,
  Switchbox,
  Typography,
} from "../../../../ppui";
import { AllowanceBox } from "../../../../pages/style";
import { TbAlertTriangle, TbPencil } from "react-icons/tb";
import useAllowanceService from "./allowance-service";
import { ALLOWANCE_INITIAL_STATE } from "./allowance-constant";

const AdminAllowanceData = ({ openSnackbar }) => {
  const {
    allowanceListinfo,
    allowance,
    handleChange,
    handleBlurFn,
    errors,
    setAllowance,
    setErrors,
    handleSubmit,
    handleUpdate,
    pagination,
    allowanceLists,
  } = useAllowanceService({ openSnackbar });

  const [open, setOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editAllowanceId, setEditAllowanceId] = useState(null);

  const handleClickOpen = () => {
    setAllowance(ALLOWANCE_INITIAL_STATE);
    setOpen(true);
    setErrors({});
    setEditAllowanceId(null)
    setIsEditMode(false);
  };
  const handleEditModalOpen = (data) => {
    setAllowance({
      allowanceName: data.allowance_name,
      allowanceType: data.allowance_type,
      allowanceValue: data.allowance_value,
      noWorkNoPay: data.no_work_no_pay,
      isEsiWages: data.is_esi_wages,
      isEpfWages: data.is_epf_wages,
      status: data.status,
    });
    setOpen(true);
    setEditAllowanceId(data.allowance_id);
    setErrors({});
    setIsEditMode(true);
  };

  const handleClose = () => {
    setOpen(false);
    setAllowance(ALLOWANCE_INITIAL_STATE);
    setErrors({});
  };

  const handleSubmitFn = async () => {
    let success = false;
    if (editAllowanceId) {
      success = await handleUpdate(editAllowanceId);
    } else {
      success = await handleSubmit();
    }

    if (!success) {
      setOpen(true);
    } else{
      setOpen(false);
    }
  };

  const handlePagination = (direction) => {
    const nextPage =
      direction === "next" ? pagination.page + 1 : pagination.page - 1;
    if (nextPage > 0 && nextPage <= pagination.totalPages) {
      allowanceLists(nextPage, pagination.pageSize);
    }
  };

  return (
    <>
      <Flex justifyContent="space-between" mb={18} gap={"10"}>
        <Typography variant="h5" mb={"0"}>
          Allowance data
        </Typography>
        <Button onClick={handleClickOpen} variant="outlined" size="sm">
          Create New
        </Button>
      </Flex>

      {allowanceListinfo.length === 0 ? (
        <AllowanceBox mb={20}>
          <Icon color={"danger"} size={"lg"}>
            <TbAlertTriangle />
          </Icon>
          <Typography
            variant="body1"
            display="flex"
            gap={10}
            alignItems="center"
            mb={0}
            p={15}
          >
            No predefined Allowance data available.
          </Typography>
        </AllowanceBox>
      ) : (
        <>
          <Flex gap={20} direction="column">
            {allowanceListinfo.map((data) => (
              <>
              <AllowanceBox key={data.id}>
                <Row alignItems="center">
                  <Col>
                    <Row alignItems="center" gap={{ md: 20, lg: 30, }}>
                      <Col md={4} xl={3}>
                        <Box className="value">{data?.allowance_name} allowance</Box>
                        <Box className="value">
                          {data?.allowance_type === "percentage" ?
                            (<>
                              {data?.allowance_value}%  of basic
                            </>) :
                            (<>
                              ₹{data?.allowance_value} {data?.allowance_type} Amount 
                            </>)
                          }
                        </Box>
                      </Col>
                      <Col md={5} xl={3}>
                        <Box className="label">{(!data?.is_epf_wages && !data?.is_esi_wages) && "Not "} Included in </Box>
                        <Box className="value">{data?.is_epf_wages && "EPF"}{(data?.is_epf_wages && data?.is_esi_wages) && " & "}{data?.is_esi_wages && "ESI"} {(!data?.is_epf_wages && !data?.is_esi_wages) && "EPF & ESI"} wages</Box>
                      </Col>
                      <Col>
                        <Box className="label"> Pay For</Box>
                        <Box className="value">{data?.no_work_no_pay ? "Present Days" : "Payable Days"}</Box>
                      </Col>
                      
                      
                      <Col>
                        <Box className="label"> Status</Box>
                        <Box className="value"><Chip
                            color={data?.status ? "success" : "danger"}
                            label={data?.status ? "Active" : "Inactive"}
                            size='sm'
                            dot
                          /> </Box>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs={"auto"}>
                    <Box>
                      <FabButton
                        size="sm"
                        icon={<TbPencil />}
                        onClick={() => handleEditModalOpen(data)}
                        variant="filled"
                        shape="box"
                      />
                    </Box>
                  </Col>
                </Row>
              </AllowanceBox>
              </>
            ))}
          </Flex>
          <Box mt={20}>
            <Flex alignItem="center" justifyContent="center" gap={10}>
              <Button
                color="default"
                colorvariant="main"
                variant="outlined"
                size="sm"
                disabled={pagination.page === 1}
                onClick={() => handlePagination("previous")}
              >
                Previous
              </Button>
              <Typography
                variant="body2"
                mb="0"
                color="dark"
                colorvariant="light"
              >
                Page {pagination.page} of {pagination.totalPages}
              </Typography>
              <Button
                color="default"
                colorvariant="main"
                variant="outlined"
                size="sm"
                disabled={pagination.page === pagination.totalPages}
                onClick={() => handlePagination("next")}
              >
                Next
              </Button>
            </Flex>
          </Box>
        </>
      )}

      {/* Create Allowance */}
      <Dialog
        closeButton={true}
        fullWidth
        maxWidth="sm"
        open={open}
        onClose={handleClose}
        onSubmit={handleSubmitFn}
        separator
        bodyScroll={true}
        title={`${!isEditMode ? "Create" : "Update"} Allowance`}
        buttonName={!isEditMode  ? "Save" : "Update"}
        footer={
          <>
          <Box mr={"auto"}>
            {isEditMode ?
             <Switchbox
                label={`${allowance.status ? "Disable" : "Enable"} Allowance`}
                lableFirst
                color="primary"
                size="lg"
                checked={allowance.status}
                error={errors.status}
                onChange={(newChecked) => handleChange(newChecked, "status")}
                onBlur={(e) => handleBlurFn(e, "status")}
              />
              : 
              <Checkbox
                size="sm"
                color="primary"
                label="Add another allowance"
              />
            }
            </Box>
          </>
      }

      >
        <Row rowGap={20}>
          <Col sm={12} md={6}>
            <InputField
              required
              fullWidth
              label="Allowance Name"
              type="text"
              placeholder="Type Here"
              valueSinc={!!allowance.allowanceName}
              value={allowance.allowanceName}
              onChange={(e) => handleChange(e.target.value, "allowanceName")}
              helperText={errors.allowanceName}
              error={errors.allowanceName}
              onBlur={(e) => handleBlurFn(e, "allowanceName")}
            />
          </Col>

          <Col sm={12} md={6}>
            <SelectField
              fullWidth
              required
              label="Type"
              options={[
                { id: "percentage", name: "Percentage" },
                { id: "fixed", name: "Fixed" },
              ]}
              placeholder="Select Here..."
              defaultValue={allowance.allowanceType}
              onChange={(val) => handleChange(val, "allowanceType")}
              error={errors.allowanceType}
              helperText={errors.allowanceType}
              onBlur={(e) => handleBlurFn(e, "allowanceType")}
            />
          </Col>
          <Col sm={12} md={6}>
            <InputField
              required
              fullWidth
              type="text"
              placeholder="Type Here"
              valueSinc={!!allowance.allowanceValue}
              value={allowance.allowanceValue}
              onChange={(e) => handleChange(e.target.value, "allowanceValue")}
              helperText={errors.allowanceValue}
              error={errors.allowanceValue}
              onBlur={(e) => handleBlurFn(e, "allowanceValue")}
              label={
                allowance.allowanceType !== "fixed" ? "Percentage" : "Amount"
              }
              suffix={allowance.allowanceType == "fixed" ? "₹" : null}
              prefix={allowance.allowanceType !== "fixed" ? "%" : null}
            />
          </Col>

          <Col sm={12} md={6}>
            <SelectField
              fullWidth
              required
              label="Pay For"
              options={[
                { id: true, name: "Present Days" },
                { id: false, name: "Payable Days" },
              ]}
              placeholder="Select Here..."
              defaultValue={allowance.noWorkNoPay}
              onChange={(val) => handleChange(val, "noWorkNoPay")}
              error={errors.noWorkNoPay}
              helperText={errors.noWorkNoPay}
              onBlur={(e) => handleBlurFn(e, "noWorkNoPay")}
            />
          </Col>

          <Col sm={"auto"}>
            <Checkbox
              color="primary"
              label="ESI Wages"
              checked={allowance.isEsiWages}
              error={errors.isEsiWages}
              onChange={(newChecked) => handleChange(newChecked, "isEsiWages")}
              onBlur={(e) => handleBlurFn(e, "isEsiWages")}
            />
          </Col>
          <Col sm={"auto"}>
            <Checkbox
              color="primary"
              label="ESI Wages"
              checked={allowance.isEpfWages}
              error={errors.isEpfWages}
              onChange={(newChecked) => handleChange(newChecked, "isEpfWages")}
              onBlur={(e) => handleBlurFn(e, "isEpfWages")}
            />
          </Col>
          <Col sm={"auto"}>
            
          </Col>
        </Row>
      </Dialog>
      {/* Create Allowance */}
    </>
  );
};

export default AdminAllowanceData;
